module.exports = __webpack_public_path__ + "img/网站3-15.249e93e0.jpg";